module.exports = __webpack_public_path__ + "static/anger-d8b444a2676eb32d9961ed6fc0af26d4.png";